import * as Ariakit from '@ariakit/react'
import { isValidElement } from 'react'

import { Tooltip, TooltipTrigger, useTooltipState } from '.'

interface WithTooltipProps {
  text: string
  settings?: Ariakit.TooltipStoreProps
}

export function WithTooltip({
  text,
  children,
  settings = { placement: 'top' },
}: React.PropsWithChildren<WithTooltipProps>) {
  const state = useTooltipState(settings)
  return (
    <>
      <TooltipTrigger state={state} render={isValidElement(children) ? children : undefined} />
      <Tooltip state={state}>{text}</Tooltip>
    </>
  )
}
